module.exports = __webpack_public_path__ + "d89c10ae7366136415aa81d91e63b30b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/LiteracyStarterIcon.png
 ** module id = 277
 ** module chunks = 0
 **/